// src/utils/navigation.ts
import { NavigateFunction } from "react-router-dom";

let navigateFn: NavigateFunction | null = null;

// This will be called once from a top-level component
export const setNavigator = (nav: NavigateFunction) => {
  navigateFn = nav;
};

export const navigateTo = (path: string) => {
  if (navigateFn) {
    navigateFn(path);
  } else {
    return;
  }
};
